export default "__VITE_ASSET__BzsWnWSY__"